import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Primary, Text, TextStyles } from "@cinch-labs/design-system";
import cx from "classnames";
import { CrossIcon } from "../image-components/cross";
import * as defaultCardStyles from "./card.module.css";
const Card = ({ children , title ="" , subtitle ="" , onClose , closeText , cardStyles , classNames , id , ...props })=>{
    const styles = cardStyles || defaultCardStyles;
    return /*#__PURE__*/ _jsxs("div", {
        className: cx(styles.card, classNames === null || classNames === void 0 ? void 0 : classNames.card),
        ...props,
        "data-id": "card",
        id: id,
        children: [
            (title || onClose) && /*#__PURE__*/ _jsxs("div", {
                className: cx(styles.title, classNames === null || classNames === void 0 ? void 0 : classNames.titleContainer),
                children: [
                    /*#__PURE__*/ _jsxs(Text, {
                        type: TextStyles.cardTitle,
                        element: "h5",
                        className: classNames === null || classNames === void 0 ? void 0 : classNames.title,
                        children: [
                            title,
                            subtitle && /*#__PURE__*/ _jsx(Text, {
                                className: styles.subtitle,
                                fontWeight: "light",
                                element: "span",
                                children: subtitle
                            })
                        ]
                    }),
                    onClose && !closeText && /*#__PURE__*/ _jsx("button", {
                        title: "Close",
                        onClick: onClose,
                        className: cx(styles.close, classNames === null || classNames === void 0 ? void 0 : classNames.closeIcon),
                        "data-testid": "card-close-button",
                        children: /*#__PURE__*/ _jsx(CrossIcon, {})
                    }),
                    onClose && closeText && /*#__PURE__*/ _jsx(Primary, {
                        onClick: onClose,
                        classNames: {
                            button: styles.textButton
                        },
                        type: "button",
                        "data-testid": "card-close-button",
                        children: closeText
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: cx(styles.body, classNames === null || classNames === void 0 ? void 0 : classNames.body),
                "data-id": "card-body",
                children: children
            })
        ]
    });
};
export default Card;
